import React from 'react'
import PropTypes from 'prop-types'
import {Button, Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {ArrowLinkIcon} from '../../icons'
import CustomDropdown from './custom-dropwdown'
import {Link as RouteLink} from 'react-router-dom'
import Link from '../../link'
import usePdTagManager from '../../../hooks/use-pd-tag-manager'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'

const PDButton = ({
    text,
    url,
    color,
    hoverType = 'default',
    ctaType,
    buttonBackgroundColor,
    buttonFontFamily,
    links = [],
    typeId,
    name,
    titlePosition = '',
    imageUrl = '',
    videoUrl = ''
}) => {
    const appOrigin = useAppOrigin()
    const pdTagManager = usePdTagManager()
    const variant = ctaType === 'link' ? 'textUnderline' : ctaType
    const hoverStyle =
        hoverType === 'nodecor' && ctaType === 'link'
            ? {
                  _hover: {
                      color: color,
                      textDecoration: 'none'
                  }
              }
            : {}
    const bg =
        buttonBackgroundColor ||
        (variant === 'button' || variant === 'buttonSmall'
            ? color === 'black'
                ? 'white'
                : 'black'
            : '')
    const isWhiteBg =
        bg?.trim().toLowerCase() === 'white' ||
        bg?.trim().toLowerCase() === '#fff' ||
        bg?.trim().toLowerCase() === '#ffffff'
    const hoverBgValue = isWhiteBg
        ? 'color-mix(in srgb, white 90%, black 10%)'
        : `color-mix(in srgb, ${bg} 88%, white 12%)`
    const route = url?.split('.com')?.[1]
    const isExternalDomain = url?.indexOf('http') !== -1
    const linkProps = isExternalDomain
        ? {to: url, as: Link, isExternal: true}
        : {as: RouteLink, to: route || url}
    const isButtonVariant = ctaType !== 'link' && ctaType !== 'textWithArrow'

    return variant === 'dropdown' ? (
        <Box className="promo-dropdown">
            <CustomDropdown
                text={text}
                buttonTextColor={color}
                buttonBgColor={buttonBackgroundColor}
                fontFamily={buttonFontFamily}
                links={links}
                type={color === 'black' ? 'light' : 'dark'}
                variant="medium"
                typeId={typeId}
                name={name}
            />
        </Box>
    ) : (
        <Button
            {...linkProps}
            variant={variant}
            color={color}
            backgroundColor={ctaType !== 'link' && ctaType !== 'textWithArrow' ? bg : undefined}
            fontFamily={buttonFontFamily}
            iconSpacing="15px"
            className="promo-button"
            rightIcon={
                variant === 'textWithArrow' ? (
                    <ArrowLinkIcon
                        className="button__arrow-icon"
                        width="15px"
                        height="15px"
                        color={color}
                        transition="transform 0.3s ease-in-out"
                    />
                ) : null
            }
            {...hoverStyle}
            onClick={() => {
                pdTagManager.selectComponent({
                    componentId: typeId,
                    componentName: name,
                    titleName: text,
                    linkUrl: url?.indexOf('http') !== -1 ? url : `${appOrigin}${url}`,
                    // Optional fields
                    titlePosition: titlePosition,
                    imageUrl: imageUrl,
                    videoUrl: videoUrl
                })
            }}
            sx={{
                _hover: {
                    ...(isButtonVariant && {backgroundColor: hoverBgValue}),
                    textDecoration: 'none'
                }
            }}
        >
            {text}
        </Button>
    )
}

PDButton.propTypes = {
    text: PropTypes.string.isRequired,
    url: PropTypes.string,
    color: PropTypes.string,
    hoverType: PropTypes.string,
    buttonFontFamily: PropTypes.string,
    ctaType: PropTypes.string,
    buttonBackgroundColor: PropTypes.string,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            url: PropTypes.string
        })
    ),
    typeId: PropTypes.string,
    name: PropTypes.any,
    titlePosition: PropTypes.any,
    imageUrl: PropTypes.any,
    videoUrl: PropTypes.any
}

export default PDButton
